import styled from 'styled-components'

export const IframeContainer = styled.div`
	width: 100%;
	height: 100%;

	iframe {
		border: 0;
		display: block;
		width: 100%;
		height: 100%;
	}
`
